import type { Currency } from "../types/currency-type";
import type { MainModel } from "../types/main-model";
import { getGameCreditsRate } from "./credits-management";

let model: MainModel;

export type CurrencyOptions = {
    credits?: boolean,
    decimals?: number,
    withCode?: boolean,
    withCodeAndFormatting?: boolean,
    skipFormatting?: boolean,
    withSymbol?: boolean,
};

export default {
    setModel(_model: MainModel){
        model = _model;
    },
}

export function getCurrencyInfo(){
    return model.clientConfig.currencies?.[model.userCurrency];
}

export function toCurrency(value: string | number, options?: CurrencyOptions): string {
    if(!options) options = {};
    
    if(typeof options.credits !== 'boolean') options.credits = true;
    if(typeof options.skipFormatting !== 'boolean') options.skipFormatting = false;
    if(typeof options.decimals !== 'number') options.decimals = 2;

    let currencyConfig = model.clientConfig.currencies?.[model.userCurrency];
    if(!currencyConfig) return value + '';

    let res = value + '';
    if(!options.skipFormatting){
        value = Number(value);
        if(isNaN(value)) return value + ''; 
        
        if(options?.credits) value /= getGameCreditsRate();

        res = new Intl.NumberFormat(currencyConfig.locale, {
            style: 'currency',
            currency: model.userCurrency,
            minimumFractionDigits: options?.decimals || 0,
        }).format(value);
    }

    if(options.withCode) res = model.userCurrency + ' ' + res.replace(/[^0-9.,]/g, '');
    if(options.withCodeAndFormatting) res = model.userCurrency + ' ' + res;
    if(options.withSymbol) res = getCurrencySymbolSmall(model.userCurrency) + res;

    return res;
}

export function getCurrencySymbolSmall(currencyCode?: Currency){
    if(!currencyCode) currencyCode = model.userCurrency;

    let currencyConfig = model.clientConfig.currencies?.[currencyCode];
    if(!currencyConfig) return '';

    return new Intl.NumberFormat(currencyConfig.locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
    }).format(0).replace(/\d+/, '');
}